<script lang="ts" setup>
  import btnIcon from '@/assets/images/AI.gif';
  import initAiChatBiSdk from './init-aiChatBi-sdk';
  import { fetchConfigSearch } from './service';

  const aiChatBiSdk = ref()
  const userId = ref('')
  const roleId = ref('')
  // 是否展示
  const isShow = ref(false)
  // 白名单
  const whiteList = ref<string[]>([])
  // 提示词
  const prompts = ref({
    prologue: '',
    question: [],
  })

  // 计时器
  const timer = ref<NodeJS.Timeout | null>(null)

  // 轮询次数
  const count = ref(0)

  const init = () => {
    userId.value = window.sessionStorage.getItem('userid') || '';
    roleId.value = window.sessionStorage.getItem('gw-bdus-rid') || '';
    // 不在白名单或还没初始化，不展示，白名单包括工号与角色id
    if (!whiteList.value.includes(userId.value) && !whiteList.value.includes(roleId.value)) {
      return
    }
    isShow.value = true;
    aiChatBiSdk.value = initAiChatBiSdk(userId.value, prompts.value);
  }

  onMounted(async () => {
    try {
      isShow.value = false;
      // 获取白名单
      const res = await fetchConfigSearch('ai_agent_search_white_list')
      // 获取智能体问题提示
      const res2 = await fetchConfigSearch('ai_agent_prompts')
      whiteList.value = res ? res.configValue.split(',') : [];
      prompts.value = res2 ? JSON.parse(res2.configValue) : {};
      timer.value = setInterval(() => {
        count.value++;
        if ((count.value > 10 || aiChatBiSdk.value) && timer.value) {
          clearInterval(timer.value);
          timer.value = null;
          return;
        }
        init();
      }, 1000);
      init()
    } catch(e) {
      console.log(e)
    }
  })

  const openAiChatBiSdk = () => {
    // 如果还没有userId.value，说明还没有初始化sdk，需要重新初始化sdk
    if (!userId.value) {
      init()
      return
    }
    if (!aiChatBiSdk.value) return;
    aiChatBiSdk.value.open();
  };
</script>

<template>
  <div v-if="isShow">
    <img class="part-to-ai-wrapper" :src="btnIcon" alt="AI助手" @click="openAiChatBiSdk" />
  </div>
</template>

<style scoped lang="less">
  @import url(./index.less);
</style>
